define([], () => {

    let submissionRef;

    let contextServiceRef;

    /*
     * Here configure additional behaviour of questions.
     * The question is identified by CODE.
     *
     * <Addon Basler Property> = <Value>:
     * {
         * CODE=<QuestionCode>
         * READONLY==<true|false>,
         * DEFAULT_VALUE=<value>, (by default, any value is RESET TO NULL)
         * AVAILABLE=<true|false>,
         * HIDE_OPTIONS=[values_to_hide]
     * }
     */
    const PRE_QUOTE__QUESTIONS_TO_HANDLE = [

        //questionset 1
        {
            get CODE() { return 'MFPUWQuestionRejectedSubmissionYesNo'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'false'; },
        },

        {
            get CODE() { return 'MFPGeneralUWQuestionsCancelledContractYesNo'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'false'; },
        },

        {
            get CODE() { return 'OBIGeneralDamageQuestion'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'false'; },
        },
        {
            get CODE() { return 'MFPGeneralUWQuestionsRemovedDrivingLicenceYesNo'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'false'; },
        },

        {
            get CODE() { return 'HadVehicleHolderAndDriversClaims'; },
            get READONLY() { return false; },
            get AVAILABLE() { return false; },
        },

        {
            get CODE() { return 'NumberLiabilityClaims'; },
            get READONLY() { return false; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'NumberCollisionClaims'; },
            get READONLY() { return false; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'NumberOtherClaims'; },
            get READONLY() { return false; },
            get AVAILABLE() { return false; },
        },

        //questionset 2
        {
            get CODE() { return 'BSLProductInfoReceived'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },

        {
            get CODE() { return 'BSLAllAnswersTrueConfirmation'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },

        {
            get CODE() { return 'BSLDataUsageConfirmend'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },

        {
            get CODE() { return 'BSLSefServiceHandlingAccepted'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },

        {
            get CODE() { return 'MFPGeneralUWQuestionsFLYesNo'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },

        //prevent household question
        {
            get CODE() { return 'HHCGeneralUWQuestionsCPYesNo'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },

        //prevent general youngGo question
        {
            get CODE() { return 'BSLAutomaticContractAdjustmentConfirmation'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },
        //prevent tcs confirmation
        {
            get CODE() { return 'BSLDataUsageConfirmendTCS'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },
    ];


    const POST_QUOTE__QUESTIONS_TO_HANDLE = [
        //questionset 1
        {
            get CODE() { return 'MFPUWQuestionRejectedSubmissionYesNo'; },
            get AVAILABLE() { return true; },
            get DEFAULT_VALUE() { return null; },
        },
        {
            get CODE() { return 'MFPGeneralUWQuestionsRemovedDrivingLicenceYesNo'; },
            get AVAILABLE() { return submissionRef.draftData.lobs.mFPLine.vehicles[0].hasVariousDrivers === false; },
            get DEFAULT_VALUE() { return null; },
        },
        {
            get CODE() { return 'OBIGeneralDamageQuestion'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'false'; },
        },
        {
            get CODE() { return 'MFPGeneralUWQuestionsCancelledContractYesNo'; },
            get AVAILABLE() { return true; },
            get DEFAULT_VALUE() { return null; },
        },

        {
            get CODE() { return 'MFPUWQuestionRejectedSubmissionCompany'; },
            get DEFAULT_VALUE() { return 'x'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'MFPUWQuestionCancelledContractCompany'; },
            get DEFAULT_VALUE() { return 'x'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'MFPUWQuestionCancelledContractContract'; },
            get DEFAULT_VALUE() { return 'x'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'MFPUWQuestionRejectedSubmissionContract'; },
            get DEFAULT_VALUE() { return 'x'; },
            get AVAILABLE() { return false; },
        },


        {
            get CODE() { return 'MFPGeneralUWQuestionsRemovedDrivingLicenceWho'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'MFPGeneralUWQuestionsRemovedDrivingLicenceDuration'; },
            get AVAILABLE() { return false; },
        },

        {
            get CODE() { return 'HadVehicleHolderAndDriversClaims'; },
            //HIDDEN due GALRE-4730 - Quote & Buy: UI - Visualization of already answered questions:   get READONLY() { return true; },  get AVAILABLE() { return true; }
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'NumberLiabilityClaims'; },
            //HIDDEN due GALRE-4730 - Quote & Buy: UI - Visualization of already answered questions:  get READONLY() { return true; },  get AVAILABLE() { return true; }
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'NumberCollisionClaims'; },
            //HIDDEN due GALRE-4730 - Quote & Buy: UI - Visualization of already answered questions:  get READONLY() { return true; }, get AVAILABLE() { var questionSet = _.findWhere(submissionRef.draftData.lobs.mFPLine.preQualQuestionSets, { code: 'MFPQuestionsToPolicyHolder'}); return Boolean(questionSet && questionSet.answers.NumberCollisionClaims);
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'NumberOtherClaims'; },
            //HIDDEN due GALRE-4730 - Quote & Buy: UI - Visualization of already answered questions:  get READONLY() { return true; }, get AVAILABLE() { return true; }
            get AVAILABLE() { return false; },
        },

        //questionset 2
        {
            get CODE() { return 'BSLProductInfoReceived'; },
            get AVAILABLE() { return false; },
        },

        {
            get CODE() { return 'BSLAllAnswersTrueConfirmation'; },
            get AVAILABLE() { return false; },
        },

        {
            get CODE() { return 'BSLDataUsageConfirmend'; },
            get AVAILABLE() { return false; },
        },

        {
            get CODE() { return 'BSLSefServiceHandlingAccepted'; },
            get AVAILABLE() { return false; },
        },

        {
            get CODE() { return 'MFPGeneralUWQuestionsFLYesNo'; },
            get AVAILABLE() { return false; },
        },

        //prevent household question
        {
            get CODE() { return 'HHCGeneralUWQuestionsCPYesNo'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },

        //prevent general youngGo question
        {
            get CODE() { return 'BSLAutomaticContractAdjustmentConfirmation'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },
        //prevent tcs confirmation
        {
            get CODE() { return 'BSLDataUsageConfirmendTCS'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },
    ];


    const CONFIRMATION__QUESTIONS_TO_HANDLE = [
        //questionset 1
        {
            get CODE() { return 'MFPUWQuestionRejectedSubmissionYesNo'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'MFPGeneralUWQuestionsRemovedDrivingLicenceYesNo'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'OBIGeneralDamageQuestion'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'false'; },
        },
        {
            get CODE() { return 'MFPUWQuestionRejectedSubmissionCompany'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'MFPGeneralUWQuestionsCancelledContractYesNo'; },
            get AVAILABLE() { return false; },
        },

        {
            get CODE() { return 'MFPUWQuestionCancelledContractCompany'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'MFPUWQuestionCancelledContractContract'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'MFPUWQuestionRejectedSubmissionContract'; },
            get AVAILABLE() { return false; },
        },

        {
            get CODE() { return 'MFPGeneralUWQuestionsRemovedDrivingLicenceWho'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'MFPGeneralUWQuestionsRemovedDrivingLicenceDuration'; },
            get AVAILABLE() { return false; },
        },

        {
            get CODE() { return 'HadVehicleHolderAndDriversClaims'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'NumberLiabilityClaims'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'NumberCollisionClaims'; },
            get AVAILABLE() { return false; },
        },
        {
            get CODE() { return 'NumberOtherClaims'; },
            get AVAILABLE() { return false; },
        },

        //questionset 2
        {
            get CODE() { return 'BSLProductInfoReceived'; },
            get AVAILABLE() { return true; },
            get DEFAULT_VALUE() { return null; },
            get HIDE_VALUES() { return ['false']; },
        },

        {
            get CODE() { return 'BSLAllAnswersTrueConfirmation'; },
            get AVAILABLE() { return true; },
            get DEFAULT_VALUE() { return null; },
            get HIDE_VALUES() { return ['false']; },
        },

        {
            get CODE() { return 'BSLDataUsageConfirmend'; },
            get AVAILABLE() { return !contextServiceRef.isTCSProduct() },
            get DEFAULT_VALUE() { return !contextServiceRef.isTCSProduct() ? null: 'true'; },
            get HIDE_VALUES() { return ['false']; },
        },

        {
            get CODE() { return 'BSLSefServiceHandlingAccepted'; },
            get AVAILABLE() { return contextServiceRef.isDirectProduct() && !submissionRef.persons[0].isCompany; },
            get DEFAULT_VALUE() { return null; },
            get HIDE_VALUES() { return ['false']; },
        },

        {
            get CODE() { return 'MFPGeneralUWQuestionsFLYesNo'; },
            get AVAILABLE() { return submissionRef.draftData.policyAddress.state === 'CH_FL'; },
            get DEFAULT_VALUE() { return null; },
            get HIDE_VALUES() { return ['false']; },
        },

        //prevent household question
        {
            get CODE() { return 'HHCGeneralUWQuestionsCPYesNo'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },

        //prevent general youngGo question
        {
            get CODE() { return 'BSLAutomaticContractAdjustmentConfirmation'; },
            get AVAILABLE() { return false; },
            get DEFAULT_VALUE() { return 'true'; },
        },

        {
            get CODE() { return 'BSLDataUsageConfirmendTCS'; },
            get AVAILABLE() { return contextServiceRef.isTCSProduct()  },
            get DEFAULT_VALUE() { return contextServiceRef.isTCSProduct() ? null: 'true'; },
        },
    ];

    return {

        //for RiskData page
        createPreQuoteConfig: function (submission, contextService) {
            submissionRef = submission;
            // ContextService not Used, if you wanna use it, then provide it on function call
            contextServiceRef = contextService;
            return PRE_QUOTE__QUESTIONS_TO_HANDLE;
        },

        //for PersonoficationData page
        createPostQuoteConfig: function (submission, contextService) {
            submissionRef = submission;
            contextServiceRef = contextService;
            return POST_QUOTE__QUESTIONS_TO_HANDLE;
        },

        //for Confirmation page
        createConfirmationConfig: function (submission, contextService) {
            submissionRef = submission;
            contextServiceRef = contextService;
            return CONFIRMATION__QUESTIONS_TO_HANDLE;
        },
    };
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/baslerquestionsets/config/SpecialQuestionsConfig.js